import { SxProps } from '@mui/material'

export const imagePreviewBox: SxProps = {
  position: 'relative',
  width: '80px',
  height: '80px',
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
}

export const filePreviewBox: SxProps = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: 2,
  padding: '8px 18.5px 8px 26px',
}
